<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        class="fill-height"
        fluid>
        <v-row
          align="center"
          justify="center">
          <v-col
            cols="12"
            sm="8"
            md="4">
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat>
                <v-toolbar-title>CAMP Fulfillment Login</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  @submit.prevent="login">
                  <v-row>
                    <v-col :cols="12">
                      <v-text-field
                        v-model="username"
                        :rules="[v => !!v || 'Username is required']"
                        label="Username"
                        name="login"
                        type="text" />
                    </v-col>
                    <v-col :cols="12">
                      <v-text-field
                        id="password"
                        v-model="password"
                        :rules="[v => !!v || 'Password is required']"
                        label="Password"
                        name="password"
                        type="password" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-spacer />
                    <v-btn
                      dark
                      :loading="loading"
                      class="mr-3"
                      type="submit"
                      color="primary">
                      Login
                    </v-btn>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import AuthProvider from '@/resources/auth.service'
import BrandProvider from '@/resources/brand.service'
import { mapActions } from 'vuex'
import { setAuthUser } from '@/utils/local-storage'

const authService = new AuthProvider()
const brandService = new BrandProvider()

export default {
  data () {
    return {
      valid: true,
      username: '',
      password: '',
      loading: false
    }
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar',
      setWarehouse: 'Warehouse/setWarehouse'
    }),
    validate () {
      this.$refs.form.validate()
    },
    async login () {
      await this.validate()
      if (!this.valid) {
        return
      }
      try {
        this.loading = true
        const { data } = await authService.login(this.username, this.password)
        setAuthUser(data)
        const warehouse = await brandService.getBrandWarehouse()
        this.setWarehouse(warehouse.data)
        this.$router.push({ name: 'Home' })
        this.setSnackBar({
          value: true,
          message: 'Login Success',
          canClose: false,
          type: 'success'
        })
      } catch (err) {
        this.setSnackBar({
          value: true,
          message: 'Username หรือ Password ไม่ถูกต้อง',
          canClose: false,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
